import {MemberPageState} from '../types/state'

export const getMemberId = (state: MemberPageState) => state.user.viewedSiteMemberId

export const getUserId = (state: MemberPageState) => state.user.currentUserId

export const isOwnProfile = (state: MemberPageState) => getMemberId(state) === getUserId(state)
